import React, { FC, useEffect } from 'react';

import { DisableBottomServiceMode__Experiment } from 'experiments/service-mode';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useStoreContext } from 'state/store';

import { BottomServiceModeView } from './bottom-service-mode.view';
import { useBottomServiceModeDetails } from './hooks/use-bottom-service-details';
import { useRoutesDisplayBottomService } from './hooks/use-routes-display-bottom-service';
import { IBottomServiceModeProps } from './types';

/**
 *
 * BottomServiceMode purpose
 *
 */
const BottomServiceMode: FC<React.PropsWithChildren<IBottomServiceModeProps>> = () => {
  const enableOrdering = useFlag(LaunchDarklyFlag.ENABLE_ORDERING);
  const bottomServiceModeDetails = useBottomServiceModeDetails();
  const { resetStore, store } = useStoreContext();
  const { CancellationModal } = bottomServiceModeDetails;

  const showBottomServiceOnRoutes = useRoutesDisplayBottomService();

  useEffect(() => {
    if (!enableOrdering) {
      resetStore();
    }
  }, [enableOrdering, store]);

  if (!showBottomServiceOnRoutes) {
    return null;
  }

  return (
    <>
      <BottomServiceModeView {...bottomServiceModeDetails} />
      <CancellationModal />
    </>
  );
};

export default function BottomServiceModeIfExperimentAllowed() {
  return (
    <DisableBottomServiceMode__Experiment>
      <BottomServiceMode />
    </DisableBottomServiceMode__Experiment>
  );
}
